/* eslint-disable react/no-array-index-key */
/* eslint-disable jsx-a11y/media-has-caption */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable react/jsx-no-target-blank */
import { useEffect, useRef, useState } from 'react'
import { useFormik } from 'formik'
import { FileDrop } from 'react-file-drop'
import { Textarea } from 'src/components/common'
import { InputField } from 'src/components/formik'
import { Select } from 'src/components/select'
import BusinessHours from 'src/components/business-hours'
import LocationSearchInput from 'src/components/place-autocomplete'
import { useAuth } from 'src/contexts/auth.context'
import { useNotification } from 'src/contexts/notification.context'
import {
  getProfileRequest,
  updateProfileRequest,
  // uploadAvatar,
  // deleteAvatar,
  uploadVideo,
  deleteVideo,
} from 'src/services/api.service'
import { filterByKeys, monthList, yearList, ROLES } from 'src/tools'

const socials = {
  square: 'fa-brands_behance-square.svg',
  twitter: 'bxl-twitter.svg',
  instagram: 'bxl-instagram-alt.svg',
  facebook: 'bxl-facebook-square.svg',
  linkedin: 'bx_bxl-linkedin-square.svg',
  youtube: 'dashicons_youtube.svg',
  pinterest: 'carbon_logo-pinterest.svg',
  google: 'icomoon-free_google-plus2.svg',
  tumblr: 'brandico_tumblr-rect.svg',
  dribbble: 'fa-brands_dribbble-square.svg',
}

const workExperienceItem = {
  profession: '',
  company: '',
  website: '',
  location: '',
  position: '',
  start_month: '',
  start_year: '',
  end_month: '',
  end_year: '',
}

const initialValues = {
  // id: null,
  first_name: '',
  last_name: '',
  email: '',
  location: '',
  description: '',
  trialLessonPrice: 0,
  trial_lesson_time: 45,
  lessonPrice: 0,
  lesson_time: 45,
  avatar: '',
  video: '',
  default_grade_id: null,
  default_subject_id: null,

  password: '',
  password_confirmation: '',

  header_image: null,

  weekdays_schedule: null,
  holydays_schedule: null,

  work_experience: [{ ...workExperienceItem }],

  awards: [],

  profession: '',
  website: '',
  social: {},
}

export const Profile = () => {
  const { user, getUser } = useAuth()
  const { wrapCallback, wrapError } = useNotification()
  const [isShowPrices, setIsShowPrices] = useState(false)
  const [isShowAwards, setIsShowAwards] = useState(false)
  const [isShowSchedule, setIsShowSchedule] = useState(true)
  const [isShowWorks, setIsShowWorks] = useState(true)
  const [isShowSocial, setIsShowSocial] = useState(true)

  const [customHeader, setCustomHeader] = useState(null)

  const fileInputRef = useRef(null)
  const awardInputRef = useRef(null)
  const headerInputRef = useRef(null)

  const formik = useFormik({
    initialValues,
    onSubmit: async (values) => {
      wrapCallback(async () => {
        await updateProfileRequest(
          filterByKeys(values, Object.keys(initialValues)),
        )
        await getUser()
      })
    },
  })

  useEffect(() => {
    const values = filterByKeys(user, Object.keys(initialValues))
    values.awards = values.awards || []
    formik.setValues(values)

    wrapError(async () => {
      const response = await getProfileRequest()
      const { user: rUser } = response.data;

      formik.setValues({
        ...rUser,
        work_experience: rUser.work_experience || [{ ...workExperienceItem }],
        social: rUser.social || {},
      })

      if ((rUser.header_image || '').indexOf('/default/') === -1) {
        setCustomHeader(rUser.header_image)
      }

      if (rUser.trialLessonPrice || rUser.lessonPrice) {
        setIsShowPrices(true)
      }

      if ((rUser.awards || []).length > 0) {
        setIsShowAwards(true)
      }
    })
  }, [])

  const onLocationChange = (value) => {
    formik.setFieldValue('location', value)
  }

  const handleAvatarChange = (e) => {
    e.preventDefault()

    if (e.target.files && e.target.files[0]) {
      const reader = new FileReader()

      reader.onloadend = (ev) => {
        formik.setFieldValue('avatar', ev.target.result)
      }

      reader.readAsDataURL(e.target.files[0])
    }
  }

  const handleAvatarDelete = (e) => {
    e.preventDefault()
    formik.setFieldValue('avatar', '')
  }

  const handleVideoChange = (e) => {
    wrapCallback(async () => {
      if (e.target.files[0]) {
        const formData = new FormData()
        formData.append('user_video', e.target.files[0])
        const response = await uploadVideo(formData)
        formik.setFieldValue('video', response.data?.user?.video)
      }
    })
  }

  const handleVideoDelete = () => {
    wrapCallback(async () => {
      await deleteVideo()
      formik.setFieldValue('video', null)
    })
  }

  const onTargetClick = () => {
    fileInputRef.current.click()
  }

  const handleAddWorkExperienceItem = (e) => {
    e.preventDefault()

    formik.setFieldValue('work_experience', [
      ...formik.values.work_experience,
      { ...workExperienceItem },
    ])
  }

  const handleRemoveWorkExperienceItem = (index) => (e) => {
    e.preventDefault()

    formik.setFieldValue('work_experience', [
      ...formik.values.work_experience.filter((x, i) => i !== index),
    ])
  }

  // Awards
  const onAwardClick = (e) => {
    e.preventDefault()
    awardInputRef.current.click()
  }

  const handleAwardsChange = () => (e) => {
    if (e.target.files && e.target.files[0]) {
      const reader = new FileReader()

      reader.onloadend = function (ev) {
        formik.setFieldValue('awards', [
          ...(formik.values.awards || []),
          { image: ev.target.result },
        ])
      }

      reader.readAsDataURL(e.target.files[0]) // convert to base64 string
    }
  }

  const handleAwardsRemove = (idx) => (e) => {
    e.preventDefault()
    formik.setFieldValue(
      'awards',
      formik.values.awards.filter((_, i) => i !== idx),
    )
  }

  // Header Image
  const handleHeaderImageClick = (e) => {
    e.preventDefault()
    headerInputRef.current.click()
  }

  const handleHeaderImageChange = (e) => {
    console.log('handleHeaderImageChange')

    if (e.target.files && e.target.files[0]) {
      const reader = new FileReader()

      reader.onloadend = function (ev) {
        formik.setFieldValue('header_image', e.target.result)
        setCustomHeader(ev.target.result)
      }

      reader.readAsDataURL(e.target.files[0]) // convert to base64 string
    }
  }

  return (
    <>
      <div className="sectionHb-top sectionHb-top__space">
        <h2 className="sectionHb-title">Profile details</h2>
      </div>

      <div className="sectionHb-block profile">
        <div className="sectionHb-block__wrap">
          <div className="profile-all">
            <div className="profile-sidebar">
              <div
                className={`profile-file ${
                  formik.values.avatar ? 'active' : ''
                }`}
                style={
                  formik.values.avatar
                    ? {
                        backgroundImage: `url(${
                          (formik.values.avatar || '').indexOf('data:image') ===
                          -1
                            ? `${process.env.REACT_APP_S3_HOST}/`
                            : ''
                        }${formik.values.avatar})`,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center center',
                      }
                    : {}
                }
              >
                <input
                  type="file"
                  accept="image/*"
                  onChange={handleAvatarChange}
                />
                <i className="hb-ico photo-ico" />
                {formik.values.avatar ? (
                  <i
                    onClick={handleAvatarDelete}
                    className="hb-ico profile-close"
                    style={{
                      position: 'absolute',
                      top: -7,
                      right: -7,
                      zIndex: 1001,
                      cursor: 'pointer',
                    }}
                  />
                ) : (
                  <i className="hb-ico circlePlus-ico" />
                )}
              </div>
            </div>

            <div className="profile-content">
              <form onSubmit={formik.handleSubmit}>
                <div className="row">
                  <div className="col-sm-6">
                    <InputField
                      formik={formik}
                      label="First name"
                      name="first_name"
                    />
                  </div>
                  <div className="col-sm-6">
                    <InputField
                      formik={formik}
                      label="Last name"
                      name="last_name"
                    />
                  </div>

                  {([ROLES.teacher, ROLES.author].includes(user.role_id) ||
                    user.author === 1) && (
                    <>
                      <div className="col-sm-6">
                        <InputField
                          formik={formik}
                          label="Profession"
                          name="profession"
                        />
                      </div>
                      <div className="col-sm-6">
                        <InputField
                          formik={formik}
                          label="Website url"
                          name="website"
                        />
                      </div>
                    </>
                  )}

                  <div className="col-sm-6">
                    <div className="input-block">
                      <label htmlFor="qf-3">Location</label>
                      <LocationSearchInput
                        onChange={onLocationChange}
                        value={formik.values.location}
                      />
                    </div>
                  </div>
                  <div className="col-sm-6">
                    <InputField
                      formik={formik}
                      label="Email"
                      name="email"
                      disabled
                    />
                  </div>

                  {([ROLES.teacher, ROLES.author].includes(user.role_id) ||
                    user.author === 1) && (
                    <>
                      <div className="col-sm-12">
                        <div className="input-block">
                          <label>Profile color</label>
                          <div className="profile-header-images">
                            {[1, 2, 3, 4, 5, 6, 7].map((x, i) => {
                              const url = `custom_header_images/default/${x}.png`

                              return (
                                <a
                                  key={i}
                                  className={
                                    formik.values.header_image === url
                                      ? 'item active'
                                      : 'item'
                                  }
                                  style={{
                                    backgroundImage: `url(${process.env.REACT_APP_S3_HOST}/${url})`,
                                  }}
                                  onClick={() => {
                                    formik.setFieldValue('header_image', url)
                                  }}
                                />
                              )
                            })}
                            <a
                              key="8"
                              className={
                                formik.values.header_image === customHeader
                                  ? 'item active'
                                  : 'item'
                              }
                              onClick={handleHeaderImageClick}
                              style={
                                customHeader && {
                                  backgroundImage: `url(${
                                    (customHeader || '').indexOf(
                                      'data:image',
                                    ) === -1
                                      ? `${process.env.REACT_APP_S3_HOST}/`
                                      : ''
                                  }${customHeader})`,
                                }
                              }
                            >
                              {customHeader ? '' : '+ Custom'}
                            </a>

                            <input
                              style={{
                                width: 1,
                                height: 1,
                                visibility: 'hidden',
                              }}
                              ref={headerInputRef}
                              accept="image/*"
                              onChange={handleHeaderImageChange}
                              type="file"
                              name="fileUpload"
                            />
                          </div>
                        </div>
                      </div>

                      <div className="col-sm-6">
                        <InputField
                          formik={formik}
                          label="Password"
                          name="password"
                        />
                      </div>

                      <div className="col-sm-6">
                        <InputField
                          formik={formik}
                          label="Password confirmation"
                          name="password_confirmation"
                        />
                      </div>

                      <div className="col-12">
                        <div className="input-block">
                          <label htmlFor="qf-7">Describe yourself</label>
                          <Textarea
                            name="description"
                            onChange={formik.handleChange}
                            value={formik.values.description}
                            status={
                              <i className="input-text">
                                <b>
                                  {(formik.values.description || '').length}
                                </b>
                                /1000 characters
                              </i>
                            }
                          />
                        </div>
                      </div>

                      <div className="col-12">
                        <div className="input-block">
                          <label htmlFor="qf-8">Upload video</label>

                          {formik.values.video ? (
                            <div className="profile-img">
                              <div className="profile-img__wrap">
                                <video width={640} controls>
                                  <source src={formik.values.video} />
                                </video>
                                <i className="hb-ico profile-play" />
                              </div>
                              <i
                                onClick={handleVideoDelete}
                                className="hb-ico profile-close"
                              />
                            </div>
                          ) : (
                            <>
                              <div className="drop">
                                <FileDrop
                                  onTargetClick={onTargetClick}
                                  onDrop={(files) => {
                                    handleVideoChange({ target: { files } })
                                  }}
                                >
                                  <input id="qf-8" type="file" />
                                  <i className="hb-ico drop-ico" />
                                  <span className="drop-title">
                                    Drag and drop
                                  </span>
                                </FileDrop>

                                <span className="drop-or">-or-</span>
                                <input
                                  accept="video/mp4,video/x-m4v,video/*"
                                  ref={fileInputRef}
                                  onChange={handleVideoChange}
                                  type="file"
                                  name="fileUpload"
                                  // className="profile__upload__file"
                                />
                                <span
                                  className="second-btn second-btn__big"
                                  onClick={onTargetClick}
                                >
                                  <i className="hb-ico plus-ico" />
                                  Upload
                                </span>
                              </div>
                            </>
                          )}
                        </div>
                      </div>

                      <div className="col-12">
                        <div
                          className={
                            isShowWorks ? 'change-all' : 'change-all active'
                          }
                        >
                          <div
                            className="change-text"
                            onClick={(e) => {
                              e.preventDefault()
                              setIsShowWorks(!isShowWorks)
                            }}
                          >
                            <span>Work experience</span>
                            <i className="hb-ico change-arrow" />
                          </div>

                          <div
                            className="change-wrap"
                            style={{ display: isShowWorks ? 'block' : 'none' }}
                          >
                            {Array.isArray(formik.values.work_experience) &&
                              formik.values.work_experience.map((x, i) => (
                                <div key={i}>
                                  <div key={i} className="work-item">
                                    {i > 0 && (
                                      <a
                                        onClick={handleRemoveWorkExperienceItem(
                                          i,
                                        )}
                                        className="remove"
                                        href="#"
                                      >
                                        <img
                                          src="/account/img/remove.svg"
                                          alt=""
                                        />
                                      </a>
                                    )}

                                    <div className="col-sm-12">
                                      <InputField
                                        formik={formik}
                                        label="Profession"
                                        name={`work_experience[${i}].profession`}
                                        value={x.profession}
                                      />
                                    </div>
                                    <div className="col-sm-6">
                                      <InputField
                                        formik={formik}
                                        label="Company / Organization"
                                        name={`work_experience[${i}].company`}
                                        value={x.company}
                                      />
                                    </div>
                                    <div className="col-sm-6">
                                      <InputField
                                        formik={formik}
                                        label="Website"
                                        name={`work_experience[${i}].website`}
                                        value={x.website}
                                      />
                                    </div>
                                    <div className="col-sm-6">
                                      <div className="input-block">
                                        <label htmlFor="qf-3">Location</label>
                                        <LocationSearchInput
                                          onChange={(value) => {
                                            formik.setFieldValue(
                                              `work_experience[${i}].location`,
                                              value,
                                            )
                                          }}
                                          value={x.location}
                                        />
                                      </div>
                                    </div>
                                    <div className="col-sm-6">
                                      <InputField
                                        formik={formik}
                                        label="Position"
                                        name={`work_experience[${i}].position`}
                                        value={x.position}
                                      />
                                    </div>

                                    <div className="col-sm-4">
                                      <div className="input-block">
                                        <label>Start</label>
                                        <Select
                                          placeholder="Month"
                                          value={x.start_month}
                                          onChange={(item) => {
                                            formik.setFieldValue(
                                              `work_experience[${i}].start_month`,
                                              item.value,
                                            )
                                          }}
                                          options={monthList.map((xx) => ({
                                            label: xx,
                                            value: xx,
                                          }))}
                                        />
                                      </div>
                                    </div>
                                    <div className="col-sm-2">
                                      <div className="input-block">
                                        <label>&nbsp;</label>
                                        <Select
                                          placeholder="Year"
                                          value={x.start_year}
                                          onChange={(item) => {
                                            formik.setFieldValue(
                                              `work_experience[${i}].start_year`,
                                              item.value,
                                            )
                                          }}
                                          options={yearList.map((xx) => ({
                                            label: xx,
                                            value: xx,
                                          }))}
                                        />
                                      </div>
                                    </div>

                                    <div className="col-sm-4">
                                      <div className="input-block">
                                        <label>End</label>
                                        <Select
                                          placeholder="Month"
                                          value={x.end_month}
                                          onChange={(item) => {
                                            formik.setFieldValue(
                                              `work_experience[${i}].end_month`,
                                              item.value,
                                            )
                                          }}
                                          options={monthList.map((xx) => ({
                                            label: xx,
                                            value: xx,
                                          }))}
                                        />
                                      </div>
                                    </div>
                                    <div className="col-sm-2">
                                      <div className="input-block">
                                        <label>&nbsp;</label>
                                        <Select
                                          placeholder="Year"
                                          value={x.end_year}
                                          onChange={(item) => {
                                            formik.setFieldValue(
                                              `work_experience[${i}].end_year`,
                                              item.value,
                                            )
                                          }}
                                          options={yearList.map((xx) => ({
                                            label: xx,
                                            value: xx,
                                          }))}
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              ))}
                            <div
                              className="col-sm-12"
                              style={{ textAlign: 'right' }}
                            >
                              <a
                                href="#"
                                onClick={handleAddWorkExperienceItem}
                                className="primary-btn primary-btn__plus"
                              >
                                <i className="hb-ico plus-ico-white" />
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="col-12">
                        <div
                          className={
                            isShowPrices ? 'change-all' : 'change-all active'
                          }
                        >
                          <div
                            className="change-text"
                            onClick={(e) => {
                              e.preventDefault()
                              setIsShowPrices(!isShowPrices)
                            }}
                          >
                            <span>
                              Private Tutoring <i>(optional)</i>
                            </span>
                            <i className="hb-ico change-arrow" />
                          </div>

                          <div
                            className="change-wrap"
                            style={{ display: isShowPrices ? 'block' : 'none' }}
                          >
                            <div className="row">
                              <div className="col-sm-3">
                                <InputField
                                  formik={formik}
                                  label="Trial lesson price"
                                  name="trialLessonPrice"
                                  placeholder="No Private Tutoring available"
                                />
                              </div>

                              <div className="col-sm-2">
                                <InputField
                                  formik={formik}
                                  label="Time"
                                  name="trial_lesson_time"
                                />
                              </div>

                              <div className="col-sm-3">
                                <InputField
                                  formik={formik}
                                  label="Lesson price"
                                  name="lessonPrice"
                                />
                              </div>
                              <div className="col-sm-2">
                                <InputField
                                  formik={formik}
                                  label="Time"
                                  name="lesson_time"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="col-12">
                        <div
                          className={
                            isShowSchedule ? 'change-all' : 'change-all active'
                          }
                        >
                          <div
                            className="change-text"
                            onClick={(e) => {
                              e.preventDefault()
                              setIsShowSchedule(!isShowSchedule)
                            }}
                          >
                            <span>Schedule</span>
                            <i className="hb-ico change-arrow" />
                          </div>

                          <div
                            className="change-wrap"
                            style={{
                              display: isShowSchedule ? 'block' : 'none',
                            }}
                          >
                            <BusinessHours
                              value={formik.values.weekdays_schedule}
                              onChange={(value) => {
                                formik.setFieldValue('weekdays_schedule', value)
                              }}
                            />
                          </div>
                        </div>
                      </div>

                      <div className="col-12">
                        <div
                          className={
                            isShowAwards
                              ? 'change-all change-all__second'
                              : 'change-all change-all__second active'
                          }
                        >
                          <div
                            className="change-text"
                            onClick={(e) => {
                              e.preventDefault()
                              setIsShowAwards(!isShowAwards)
                            }}
                          >
                            <span>
                              Awards <i>(optional)</i>
                            </span>
                            <i className="hb-ico change-arrow" />
                          </div>

                          <div
                            className="change-wrap"
                            style={{ display: isShowAwards ? 'block' : 'none' }}
                          >
                            <div className="row">
                              <div className="col-md-12 col-12">
                                <div
                                  className="input-block"
                                  style={{ display: 'flex' }}
                                >
                                  <input
                                    type="text"
                                    name="text"
                                    placeholder="No awards available"
                                    style={{ flex: 1 }}
                                  />
                                  <input
                                    style={{
                                      width: 1,
                                      height: 1,
                                      visibility: 'hidden',
                                    }}
                                    ref={awardInputRef}
                                    accept="image/*"
                                    onChange={handleAwardsChange(
                                      formik.values?.awards?.length || 0,
                                    )}
                                    type="file"
                                    name="fileUpload"
                                  />
                                  <a
                                    onClick={onAwardClick}
                                    href="#"
                                    className="second-btn second-btn__big"
                                    style={{
                                      width: 'auto',
                                      padding: '6px 32px 6px 60px',
                                      marginLeft: '20px',
                                    }}
                                  >
                                    <i className="hb-ico plus-ico" />
                                    Upload
                                  </a>
                                </div>
                              </div>
                              <div className="col-md-2 col-12">
                                <div className="input-block" />
                              </div>
                            </div>

                            {/* <a href="#" class="primary-btn primary-btn__plus"><i class="hb-ico plus-ico-white"></i></a> */}

                            <div className="profile-list">
                              {Array.isArray(formik.values.awards) &&
                                formik.values.awards.map((x, i) => (
                                  <div key={i} className="profile-img">
                                    <div
                                      className="profile-img__wrap"
                                      style={{
                                        backgroundImage: `url(${
                                          (x.image || '').indexOf(
                                            'data:image',
                                          ) !== -1
                                            ? x.image
                                            : `${process.env.REACT_APP_S3_HOST}/${x.image}`
                                        })`,
                                      }}
                                    />
                                    <i
                                      onClick={handleAwardsRemove(i)}
                                      className="hb-ico profile-close"
                                    />
                                  </div>
                                ))}
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="col-12">
                        <div
                          className={
                            isShowSocial
                              ? 'change-all change-all__second'
                              : 'change-all change-all__second active'
                          }
                        >
                          <div
                            className="change-text"
                            onClick={(e) => {
                              e.preventDefault()
                              setIsShowSocial(!isShowSocial)
                            }}
                          >
                            <span>
                              Social links <i>(optional)</i>
                            </span>
                            <i className="hb-ico change-arrow" />
                          </div>

                          <div
                            className="change-wrap"
                            style={{ display: isShowSocial ? 'block' : 'none' }}
                          >
                            {Object.keys(socials).map((x) => (
                              <div key={x} className="row">
                                {/* <div class="col-md-2 col-1">
                                  <div class="input-block">
                                    <img src={`/account/img/profileSocial/${socials[x]}`} alt="" />
                                  </div>
                                </div> */}
                                <div className="col-md-12 col-12">
                                  <div
                                    className="input-block"
                                    style={{
                                      justifyContent: 'center',
                                      display: 'flex',
                                      flexDirection: 'row',
                                    }}
                                  >
                                    <img
                                      src={`/account/img/profileSocial/${socials[x]}`}
                                      alt=""
                                      style={{ marginRight: 15 }}
                                    />

                                    <input
                                      value={(formik.values.social || {})[x]}
                                      onChange={(e) => {
                                        formik.setFieldValue(
                                          `social.${x}`,
                                          e.target.value,
                                        )
                                      }}
                                      type="text"
                                      name="text"
                                      placeholder="URL"
                                    />
                                  </div>
                                </div>
                              </div>
                            ))}
                          </div>
                        </div>
                      </div>
                    </>
                  )}

                  <div className="col-12">
                    <div className="profile-bottom buttons-row">
                      <button type="submit" className="primary-btn">Save</button>
                      {([ROLES.teacher, ROLES.author].includes(user.role_id) ||
                        user.author === 1) && (
                        <a
                          href={`${process.env.REACT_APP_API_HOST}/authors/${user.id}`}
                          target="_blank"
                          className="second-btn"
                        >
                          Preview
                        </a>
                      )}
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
